import image from './Image/index';
import spreadsheet from './Spreadsheet/index';
import pdf from './Pdf/index';
import document from './Document/index';
import presentation from './Presentation';
import qrCode from './QrCode/index';
import text from './Text/index';

const types = {
  image,
  spreadsheet,
  pdf,
  document,
  presentation,
  'qr-code': qrCode,
  text
};

export default types;
